"use client";
import { motion, useAnimation, useInView } from "framer-motion";
import { useEffect, useRef } from "react";

export default function FadeInOnScroll({ children }) {
  const controls = useAnimation();
  const ref = useRef(null);
  const hasAnimatedRef = useRef(false);

  const isInView = useInView(ref, {
    margin: "-100px",
    once: true, // ✅ 关键
  });

  useEffect(() => {
    if (isInView && !hasAnimatedRef.current) {
      hasAnimatedRef.current = true;
      controls.start("visible");
    }
  }, [isInView, controls]);

  return (
    <motion.div
      ref={ref}
      initial="hidden"
      animate={controls}
      transition={{ duration: 0.8, ease: "easeInOut" }}
      variants={{
        hidden: { opacity: 0, y: 60, scale: 0.95 },
        visible: { opacity: 1, y: 0, scale: 1 },
      }}
    >
      {children}
    </motion.div>
  );
}
